import { ChangeEventHandler, FC, useState } from 'react';

import useSWRMutation from 'swr/mutation';

import Checkbox from '@mui/material/Checkbox';

import { slotService } from 'v2/api/slotService';
import { SlotModel } from 'v2/types/SlotModel';
import { handleHttpError } from 'v2/utils';

interface SlotTableActiveColumnProps {
  slot: SlotModel;
}

export const SlotTableActiveColumn: FC<SlotTableActiveColumnProps> = ({ slot }) => {
  const [isChecked, setChecked] = useState(slot.isActive);

  const { trigger } = useSWRMutation(['updateSlotStatus', slot.id], slotService.updateSlotStatus, {
    onSuccess: (slot) => {
      setChecked(slot.isActive);
    },
    onError: handleHttpError,
  });

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    trigger(e.target.checked);
  };

  return <Checkbox color="success" checked={isChecked} onChange={handleChange} />;
};
